"use client";

import { LuSearch } from "react-icons/lu";

import { useDetectMacOS } from "@/hooks/use-detect-mac-os";
import { cn } from "@/utils/lib";

type SearchDialogTriggerInputProps = {
  className?: string;
  onOpen: () => void;
};

export const SearchDialogTriggerInput = ({
  className,
  onOpen,
}: SearchDialogTriggerInputProps) => {
  const { isMacOS, osLoading } = useDetectMacOS();

  return (
    <div className="w-full">
      <div className={cn("relative flex gap-4")}>
        <div
          className="
            pointer-events-none absolute top-[10px] right-[14px] flex
            items-center gap-2 text-muted
          "
        >
          {!osLoading && (
            <kbd
              className="
                inline-flex items-center gap-1 font-mono text-[12px]
                font-medium text-muted opacity-100 select-none
              "
            >
              <span className="text-sm">{isMacOS ? "⌘" : "Ctrl+"}</span> K
            </kbd>
          )}

          <LuSearch />
        </div>
        <button
          type="button"
          aria-label="Open search"
          className={cn(
            `
              flex
              w-full
              cursor-text
              rounded-full border border-border-light
              bg-input
              px-3 py-2 text-left text-sm text-muted ring-offset-background
              focus:border-foreground
              focus-visible:outline-hidden
            `,
            className,
          )}
          onClick={(event) => {
            if (event.detail === 0) {
              onOpen();
              return;
            }

            requestAnimationFrame(() => {
              onOpen();
            });
          }}
        >
          <span className="truncate">Search...</span>
        </button>
      </div>
    </div>
  );
};
